<template>
    <div class="a-container" style="width: 100%;height:100%;overflow-y:auto;" ref="scrollContainer" @scroll="scrollToTop">
        <breadcrumb :breadcrumbConfig=breadcrumbConfig></breadcrumb>
        <div class="content">
            <h2>全部订单</h2>
            <h3>数据筛选</h3>
            <form-filed class="search-form1" :formconfig="searchFormConfig.formconfig" :formData="searchFormConfig.formData"
                @formDataval="dialogClick" ref="formAttr" />
        </div>
        <div class="content">
            <div style="display: flex;">
                <h3>数据列表</h3>
                <div style="line-height: 28px;margin-left: 10px;color: #999999;">当前数据统计 实收金额<span style="color: red;">￥{{
                    actualReceivedAmount }}</span>，已通过审核的核销金额<span style="color: red;">￥{{ amount }}</span>
                </div>
            </div>

            <div class="but-list">
                <div class="left">
                    <el-button v-for="(val, key) in logisticsStatus" :key="key" style="margin-bottom: 10px;"
                        :type="currentStatus === val.values ? 'primary' : 'info'" size="small" plain
                        @click="onChangeLogisticsStatus(val.values)">{{ val.title }}<span>({{ val.total
                        }})</span>
                    </el-button>
                </div>
                <div class="right">
                    <el-button type="warning" size="small" @click="onComissionListExport()"
                        v-if="parArray.indexOf('Export_commission_list') != -1">导出提成列表
                    </el-button>
                    <el-button type="warning" size="small" @click="onImport('4')"
                        v-if="parArray.indexOf('Batch_import_commission') != -1">批量导入提成</el-button>
                    <el-button type="warning" size="small" v-if="parArray.indexOf('Export_audit_list') != -1"
                        @click="onApplyListExport()">导出审核列表
                    </el-button>
                    <el-button type="warning" size="small" @click="onImport('3')"
                        v-if="parArray.indexOf('Batch_import_review') != -1">批量导入审核</el-button>
                    <el-button type="warning" size="small" class="stay-deliver-goods-but"
                        v-if="parArray.indexOf('export_hx') != -1" @click="onApplyListHExport()">导出核销列表
                    </el-button>
                    <el-button type="warning" size="small" @click="onImport('1')"
                        v-if="parArray.indexOf('batch_Import_Write_off') != -1">批量导入核销
                    </el-button>
                    <el-button type="primary" size="small" class="stock-up-send-but" @click="onApplierExport()"
                        v-if="parArray.indexOf('Export_order') != -1">导出订单
                    </el-button>
                    <el-button type="primary" size="small" class="stock-up-record-but" @click="onImport('2')"
                        v-if="parArray.indexOf('Batch_import_orders') != -1">批量导入订单
                    </el-button>
                    <el-button type="primary" size="small" class="stay-deliver-goods-but"
                        v-if="parArray.indexOf('Download_order_template') != -1"
                        @click="downloadlink('https://fenxiao.muruji.com/5eck/%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BFv1.0.5.xls')">下载订单模板
                    </el-button>
                </div>
            </div>
            <div id="base-list">
                <lb-table3 v-horizontal-scroll='"always"' :column="columns" :data="page.list" pagination
                    :tableHeight="tableHeight" :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[5, 10, 20, 30, 50, 200]" :current-page.sync="page.currentPage" :page-size="page.pageSize"
                    @size-change="handleSizeChange" @p-current-change="handleCurrentChange"
                    @selection-change="handleSelectionChange">
                </lb-table3>
            </div>
        </div>
        <el-dialog :title="dialog.title" :visible.sync="dialog.visible" :width="dialog.width" :append-to-body="true">
            <!-- 审核 -->
            <template v-if="dialog.type == 'shenheList'">
                <audit-operation ref="shenheList" :orderObj="dialog.row" :dialogType='dialog.type'
                    :afterNos="multipleSelection" :isBatch="dialog.batch" :isCleanUp='true' :orderAllId="currentRow.id"
                    @submitState="shenheState"></audit-operation>
                <div class="dialogBtnright" style="margin-top:20px">
                    <el-button class="setPay_payment_btn_quxiao" type="primary" plain
                        @click="dialog.visible = false">取消</el-button>
                    <el-button class="setPay_payment_btn_queren" type="primary" @click="submitApply()">确 定</el-button>
                </div>
            </template>
            <!-- 进度 -->
            <template v-if="dialog.type === 'shenheStep'">
                <step-progress :apply="applys" :processFunc="dictionaries.process_func" type="shenheStep"></step-progress>
            </template>
            <!--物流 -->
            <template v-if="dialog.type === 'logistics'">
                <StepLogistics :stepProgress="logisticsNode"></StepLogistics>
            </template>
        </el-dialog>
        <el-dialog title="是否已核算提成" :visible.sync="isCommission" width="640px" :append-to-body="true">
            <template>
                <el-form :inline="true" :model="commissionForm" ref="commissionForm" size="small" label-width="120px">
                    <el-form-item label="是否已核算提成" prop="commissionFlag">
                        <el-select style="width: 400px;" v-model="commissionForm.commissionFlag" placeholder="请选择是否已核算提成"
                            clearable>
                            <el-option v-for="item in commissions" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="提成备注">
                        <el-input type="textarea" v-model="commissionForm.commissionRemark" style="width: 400px;"
                            placeholder="请输入"></el-input>
                    </el-form-item>
                </el-form>
                <div class="dialogBtnright" style="margin-top:20px">
                    <el-button class="setPay_payment_btn_quxiao" type="primary" plain
                        @click="isCommission = false">取消</el-button>
                    <el-button class="setPay_payment_btn_queren" type="primary" @click="submitComission">提交</el-button>
                </div>
            </template>
        </el-dialog>
        <el-dialog title="导入" :visible.sync="isImport" width="640px" :append-to-body="true">
            <template>
                <div class="popIn">
                    <el-upload ref="tops" class="upload-demo" accept=".doc,.docx,.xls,.xlsx,.csv" drag action="#"
                        :multiple="false" :http-request="orderImport" :limit="1">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                            将文件拖到此处，或<em>点击上传</em>
                        </div>
                    </el-upload>
                </div>
                <div class="dialog-footer">
                    <div @click="downloadTemplate">
                        <el-button type="text" icon="el-icon-download">导入模板下载</el-button>
                    </div>
                    <div>
                        <el-button class="cancel" @click="isImport = false">取消
                        </el-button>
                        <el-button class="affirm" type="primary" @click="submitF">确定
                        </el-button>
                    </div>
                </div>
            </template>
        </el-dialog>
        <el-dialog :title="title" :visible.sync="isPayment" width="50%" :append-to-body="true">
            <el-table :data="hList" border>
                <el-table-column prop="orderNo" label="订单编号">
                </el-table-column>
                <el-table-column prop="receivableAmount" label="订单应收金额"></el-table-column>
                <el-table-column prop="actualReceivedAmount" label="订单实收金额"></el-table-column>
                <el-table-column prop="yAmount" label="已核销总金额"></el-table-column>
                <el-table-column prop="otherAmount" label="其他金额"></el-table-column>
            </el-table>
            <el-form :model="paymentForm" label-width="100px" :inline="true" :rules="rules" ref="paymentForm"
                style="margin-top: 20px;">
                <div v-for="(item, index) in paymentForm.list" :key="index">
                    <div class="p-title">第{{ index + 1 }}笔核销</div>
                    <el-form-item label="结算方式" :prop="`list.${index}.settlementModes`" :rules="rules.settlementModes">
                        <el-select style="width: 260px;" size="small" v-model="item.settlementModes" placeholder="请选择结算方式"
                            clearable>
                            <el-option v-for="item in settlementTypes" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>

                        </el-select>
                    </el-form-item>
                    <el-form-item label="到账时间" prop="receiveTime" :prop="`list.${index}.receiveTime`"
                        :rules="rules.receiveTime">
                        <el-date-picker style="width: 260px;" size="small" v-model="item.receiveTime" type="date"
                            value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="回款渠道" prop="returnChannelId" :prop="`list.${index}.returnChannelId`"
                        :rules="rules.returnChannelId">
                        <el-select style="width: 260px;" size="small" v-model="item.returnChannelId" placeholder="请选择回款渠道"
                            clearable filterable>
                            <el-option v-for="item in channels" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="核销金额" :prop="`list.${index}.amount`" :rules="rules.amount">
                        <el-input size="small" v-model="item.amount" placeholder="请输入核销金额" style="width: 260px;"
                            oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
                            @change="changeType($event)"></el-input>
                    </el-form-item>
                </div>
                <div style="display: flex;justify-content: center;margin-top: 20px;margin-bottom: 20px;"
                    v-if="paymentForm.list.length < 2">
                    <el-button type="primary" icon="el-icon-plus" @click="addPrice">新增核销金额</el-button>
                </div>
                <div style="width: 100%;height: 1px;background-color: #e3e3e3;"></div>
                <div style="margin-top: 20px;">
                    <el-form-item label="核销类型" prop="status" :rules="rules.status">
                        <el-select style="width: 260px;" size="small" v-model="paymentForm.status" placeholder="请选择核销类型"
                            clearable>
                            <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id">
                            </el-option></el-select>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item label="核销备注">
                        <el-input type="textarea" v-model="paymentForm.writeOffRemarks" style="width: 630px;"
                            placeholder="请输入"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnright" style="margin-top:20px">
                <el-button class="setPay_payment_btn_quxiao" type="primary" plain @click="isPayment = false">取 消</el-button>
                <el-button class="setPay_payment_btn_queren" type="primary" @click="actionDialog">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import formFiled from '@/components/form/index'
import breadcrumb from '@/components/breadcrumb'
import LbTable3 from '@/components/lb-table3/lb-table'
import mixinsCommon from '../orderBox/mixins/common.js'
import mixinsOrderList from '../orderBox/mixins/mixinsOrderList.js'
import StepProgress from '@/components/StepProgress1'
import AuditOperation from '@/components/AuditOperation1'
import StepLogistics from './components/StepLogistics.vue'
export default {
    mixins: [mixinsCommon, mixinsOrderList],
    components: {
        formFiled,
        breadcrumb,
        LbTable3,
        StepProgress,
        AuditOperation,
        StepLogistics
    },
    data() {
        return {
            countBonusReviewStatus: '',
            showBonusStatus: true,
            logisticsNode: {},
            hList: [
                {
                    orderNo: '',
                    receivableAmount: '',
                    actualReceivedAmount: '',
                    yAmount: '',
                    otherAmount: '0.00',
                }
            ],
            tableHeight: '',
            applys: [],
            isType: '',
            types: [
                {
                    id: '1',
                    name: '部分核销'
                },
                {
                    id: '2',
                    name: '已核销'
                },
                {
                    id: '3',
                    name: '强制核销'
                }
            ],
            actualReceivedAmount: 0,
            amount: 0,
            isImport: false,
            isSingle: false,
            isCommission: false,
            commissions: [
                {
                    id: '1',
                    name: '是'
                },
                {
                    id: '0',
                    name: '否'
                }
            ],
            commissionForm: {
                id: '',
                commissionFlag: '',
                commissionRemark: ''
            },
            paymentForm: {
                list: [
                    {
                        id: '',
                        settlementModes: '',
                        returnChannelId: '',
                        amount: '',
                        receiveTime: ''
                    },
                    // {
                    //     payTime: '',
                    //     payChannel: '',
                    //     payMoney: '',
                    //     payType: ''
                    // }
                ],
                status: '',
                writeOffRemarks: ''

            },
            rules: {
                settlementModes: [{ required: true, message: '请选择结算方式', trigger: 'change' }],
                receiveTime: [{ required: true, message: '请选择到账时间', trigger: 'change' }],
                returnChannelId: [{ required: true, message: '请选择回款渠道', trigger: 'change' }],
                amount: [{ required: true, message: '请输入核销金额', trigger: 'blur' }],
                status: [{ required: true, message: '请选择核销类型', trigger: 'change' }],
            },
            title: '编辑回款内容',
            dialog: {
                title: '订单财务审核',
                visible: false,
                type: '',
                width: '50%',
                row: {}
            },
            currentStatus: 0,
            logisticsStatus: [
                { title: '全部', values: 0, total: 0 }, // 全部
                { title: '待发货', values: 1, total: 0 },
                { title: '已发货', values: 2, total: 0 },
                { title: '售后进行中', values: 3, total: 0 },
                { title: '售后完成', values: 4, total: 0 },
                { title: '待核销', values: 5, total: 0 },
                { title: '强制核销', values: 6, total: 0 },
                { title: '部分核销', values: 7, total: 0 },
                { title: '核销退回', values: 8, total: 0 },
                { title: '已核销', values: 9, total: 0 },
                { title: '待审核', values: 10, total: 0 },
                { title: '审核通过', values: 11, total: 0 },
                { title: '驳回', values: 12, total: 0 },
                { title: '申诉审核中', values: 13, total: 0 },
                { title: '申诉驳回', values: 14, total: 0 },
                { title: '申诉通过', values: 15, total: 0 },
                { title: '被改提成', values: 16, total: 0 }
            ],
            loading: false,
            dialog: { visible: false, title: '审核', type: '', width: '50%', row: {} },
            page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1 },
            examine: { // 是否通过审核
                state: '1',
                ids: [],
                doc: ''
            },
            orderStatus: [],
            breadcrumbConfig: {
                list: [
                    {
                        title: '订单管理',
                        type: '#ff0000',
                        path: ''
                    },
                    {
                        title: '全部订单',
                        type: '1',
                        path: ''
                    }
                ]
            },
            searchFormVal: {},
            searchFormConfig: {
                formconfig: {
                    labeWidth: 124, // 表单宽度
                    itemList: [// 表单的list
                        { type: 'input', prop: 'orderNo', placeholder: '请输入订单编号', label: '订单编号', size: 'small' },
                        { type: 'input', prop: 'platformOrderNo', placeholder: '请输入关联订单号', label: '关联订单号', size: 'small' },
                        { type: 'input', prop: 'transactionId', placeholder: '请输入支付流水号', label: '支付流水号', size: 'small' },
                        { type: 'daterange', prop: 'createdTime', placeholder: '请选择日期', label: '订单生成时间', size: 'small' },
                        {
                            type: 'select', prop: 'auditStatus', placeholder: '请选择财务审核状态', label: '财务审核状态', size: 'small',
                            option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
                        },
                        {
                            type: 'cascader', prop: 'orgCode', placeholder: '请选择公司部门', label: '公司部门', size: 'small', showAllLevels: false,
                            option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2跟进客服' }]
                        },
                        {
                            type: 'select', prop: 'orderGenerateType', placeholder: '请选择订单分类', label: '订单分类', size: 'small',
                            option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
                        },
                        {
                            type: 'select', prop: 'orderOrigin', placeholder: '请选择订单来源', label: '订单来源', size: 'small',
                            option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
                        },

                        { type: 'input', prop: 'userName', placeholder: '请输入客户姓名', label: '客户姓名', size: 'small' },
                        { type: 'input', prop: 'postName', placeholder: '请输入收货人', label: '收货人', size: 'small' },
                        { type: 'input', prop: 'goodsName', placeholder: '请输入商品名称', label: '商品名称', size: 'small' },
                        {
                            type: 'select', prop: 'codFlag', placeholder: '请选择是否货到付款', label: '是否货到付款', size: 'small',
                            option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
                        },
                        {
                            type: 'select', prop: 'purchaseFlag', placeholder: '请选择内购价标记', label: '内购价标记', size: 'small', showAllLevels: false,
                            option: [{ label: '使用内购价', value: '1' }, { label: '未使用', value: '0' }]
                        },
                        {
                            type: 'select', prop: 'bonusType', placeholder: '请选择提成类型', label: '提成类型', size: 'small',
                            option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
                        },
                        {
                        type: 'select', prop: 'bonusReviewStatus', placeholder: '请选择申诉审核状态', label: '申诉审核状态', size: 'small',
                        option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
                        }



                    ],
                    btnarry: [// 表单按钮
                        { name: '查询', click: 'add', type: 'primary', plain: true, size: 'small' },
                        { name: '重置', click: 'clrear', type: 'primary', plain: true, size: 'small' }
                    ]
                },
                formData: { // 表单提交数据，
                    orderNo: '',
                    platformOrderNo: '',
                    transactionId: '',
                    createdTime: [],
                    auditStatus: '',
                    orderGenerateType: '',
                    orderOrigin: '',
                    userName: '',
                    postName: '',
                    goodsName: '',
                    codeFlag: '',
                    purchaseFlag: '',
                    orgCode: [],
                    bonusType: '',
                    bonusReviewStatus: '',
                    countBonusReviewStatus: '',
                    checkbox: []// 注：如果类型是checkbox，必须foemData里边提前声明数组
                }
            },
            columns: [
                {
                    label: '订单号',
                    width: '260',
                    prop: 'orderNo',
                    fixed: 'left',
                    render: (h, scope) => {
                        return (
                            <div>
                                <div style="color:#0b7df3">订单编号：{scope.row.orderNo || '--'}</div>
                                <div>关联订单号：{scope.row.platformOrderNo || '--'}</div>
                            </div>
                        )
                    }
                },
                {
                    label: '订单分类',
                    width: '100',
                    prop: 'orderGenerateType',
                    render: (h, scope) => {
                        let v = ''
                        const payIndex1 = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '订单分类' })
                        this.searchFormConfig.formconfig.itemList[payIndex1].option.forEach(item => {
                            if (item.value == scope.row.orderGenerateType) {
                                v = item.label
                            }
                        })
                        return (
                            <div>
                                {scope.row.orderGenerateTypeLabel || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '订单端口（类型）',
                    prop: 'orderPort',
                    minWidth: '150',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.row.orderPort || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '提成类型',
                    prop: 'bonusType',
                    minWidth: '150',
                    render: (h, scope) => {
                        let v = '--'
                        if (scope.row.bonusType === 1 ) {
                            v = '首购提成'
                        } else if (scope.row.bonusType === 2 ) {
                            v = '复购提成'
                        }
                        return (
                            <div>
                                {v}
                            </div>
                        )
                    }
                },

                {
                    label: '订单来源',
                    prop: 'orderOrigin',
                    width: '120',
                    render: (h, scope) => {
                        // let v = ''
                        // const payIndex1 = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '订单来源' })
                        // this.searchFormConfig.formconfig.itemList[payIndex1].option.forEach(item => {
                        //     console.log(item)
                        //     if (item.value == scope.row.orderOrigin) {
                        //         v = item.label
                        //     }
                        // })
                        return (
                            <div>
                                {scope.row.orderOriginLabel || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '店铺名称',
                    prop: 'shopName',
                    width: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.row.shopName || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '支付流水号',
                    prop: 'transactionId',
                    width: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.row.transactionId || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '商品名称',
                    prop: 'skuName',
                    width: '400',
                    render: (h, scope) => {
                        if (!scope.row.goodsAfterInfoList) return
                        return (
                            <div style="text-align:left">
                                {
                                    scope.row.goodsAfterInfoList.map(item => {
                                        return (
                                            <div style="display:flex;margin-bottom:10px">
                                                <img style="width:80px;height:80px" src={item.image} preview-src-list={item.image} lazy></img>
                                                <div style="display:flex;justify-content:space-between;flex-direction:column;margin-left:10px">
                                                    <p style="overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;text-overflow: ellipsis;">{item.goodsName || '--'}</p>
                                                    <p style="color:#999999">{item.skuName || '--'}</p>
                                                </div>

                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: 'SKU零售价',
                    prop: 'retailPrice',
                    width: '120',
                    render: (h, scope) => {
                        if (!scope.row.goodsAfterInfoList) return
                        return (
                            <div style="text-align:left;height:100%">
                                {
                                    scope.row.goodsAfterInfoList.map(item => {
                                        return (
                                            <div style="display:flex;flex-direction:column;justify-content:center;height:80px;">
                                                ￥{item.retailPrice || '--'}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: 'SKU活动价',
                    prop: 'activityPrice',
                    width: '120',
                    render: (h, scope) => {
                        if (!scope.row.goodsAfterInfoList) return
                        return (
                            <div style="text-align:left;height:100%">
                                {
                                    scope.row.goodsAfterInfoList.map(item => {
                                        return (
                                            <div style="display:flex;flex-direction:column;justify-content:center;height:80px;">
                                                ￥{item.activityPrice || '--'}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: 'SKU最后成交价',
                    prop: 'lastPrice',
                    width: '200',
                    render: (h, scope) => {
                        if (!scope.row.goodsAfterInfoList) return
                        return (
                            <div style="text-align:left;height:100%">
                                {
                                    scope.row.goodsAfterInfoList.map(item => {
                                        return (
                                            <div style="display:flex;flex-direction:column;justify-content:center;height:80px;">
                                                ￥--
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: '订单商品数',
                    prop: 'quantity',
                    width: '120',
                    render: (h, scope) => {
                        if (!scope.row.goodsAfterInfoList) return
                        return (
                            <div style="text-align:left;height:100%">
                                {
                                    scope.row.goodsAfterInfoList.map(item => {
                                        return (
                                            <div style="display:flex;flex-direction:column;justify-content:center;height:80px;">
                                                {item.quantity || '--'}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: '订单应收金额',
                    prop: 'receivableAmount',
                    minWidth: '240',
                    renderHeader: (h, scope) => {
                        return (
                            <div>
                                <div style="text-align:center">订单应收金额<el-tooltip class="item" effect="dark" content="(商品总价 + 运费  - 优惠金额)"
                                    placement="top-start">
                                    <i class="el-icon-question"></i> </el-tooltip></div>
                            </div>
                        )
                    },
                    render: (h, scope) => {
                        let v = ''
                        if (scope.row.receivableAmount == null) {
                            v = '--'
                        } else {
                            v = scope.row.receivableAmount
                        }
                        return (
                            <div style="text-align:center">
                                ￥{v}
                            </div>
                        )
                    }
                },
                {
                    label: '订单实收金额',
                    prop: 'actualReceivedAmount',
                    minWidth: '240',
                    renderHeader: (h, scope) => {
                        return (
                            <div>
                                <div style="text-align:center">订单实收金额<el-tooltip class="item" effect="dark" content="（应收金额  - 售后件金额）"
                                    placement="top-start">
                                    <i class="el-icon-question"></i> </el-tooltip></div>
                            </div>
                        )
                    },
                    render: (h, scope) => {
                        let v = ''
                        if (scope.row.actualReceivedAmount == null) {
                            v = '--'
                        } else {
                            v = scope.row.actualReceivedAmount
                        }
                        return (
                            <div style="text-align:center">
                                ￥{v}
                            </div>
                        )
                    }
                },
                {
                    label: '是否到付',
                    prop: 'codFlag',
                    width: '120',
                    render: (h, scope) => {
                        let v = ''
                        if (scope.row.codFlag == 1) {
                            v = '是'
                        } else {
                            v = '否'
                        }
                        return (
                            <div>
                                {v || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '客户名称',
                    prop: 'userName',
                    width: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.row.userName || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '收件人',
                    prop: 'postName',
                    width: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.row.postName || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '收件人号码',
                    prop: 'postContact',
                    width: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.row.postContact || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '收货人地址',
                    prop: 'postAddress',
                    width: '300',
                    render: (h, scope) => {
                        let v = ''
                        if (scope.row.orderGenerateType == 2 || scope.row.orderGenerateType == 3) {
                            v = scope.row.postAddressDetail
                        } else {
                            v = scope.row.postAddress + scope.row.postAddressDetail
                        }
                        return (
                            <div>
                                {v || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '下单时间',
                    prop: 'submitTime',
                    width: '200',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.row.submitTime || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '发货时间',
                    prop: 'postDeliverTime',
                    width: '200',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.row.postDeliverTime || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '订单状态',
                    prop: 'status',
                    width: '120',
                    render: (h, scope) => {
                        let v = ''
                        if (scope.row.afterSalesStatus && (scope.row.afterSalesStatus == 1 || scope.row.afterSalesStatus == 2)) {
                            v = scope.row.afterSalesStatusLabel
                            //  if (scope.row.afterSalesStatus == 1) {
                            //     v = "售后进行中"
                            // } else {
                            //     v = "售后完成"
                            // }
                        } else {
                            this.orderList.forEach(item => {
                                // console.log(item)
                                if (item.value == scope.row.status) {
                                    v = item.label
                                }
                            })
                        }
                        return (
                            <div>
                                {v}
                            </div>
                        )
                    }
                },
                {
                    label: '客服部门',
                    prop: 'sysUserOrg',
                    width: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.row.sysUserOrg || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '跟进客服',
                    prop: 'sysUserName',
                    width: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.row.sysUserName || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '快递公司',
                    prop: 'logisticsCompany',
                    width: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.row.logisticsCompany || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '物流单号',
                    prop: 'logisticsNumber',
                    width: '200',
                    render: (h, scope) => {
                        return (
                            <div style="color:#409Eff;cursor:pointer" onClick={() => { this.lookLogistics(scope.row) }}>
                                {scope.row.logisticsNumber || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '是否存在退货',
                    prop: 'goodsRejectedFlag',
                    width: '120',
                    render: (h, scope) => {
                        let v = ''
                        if (scope.row.goodsRejectedFlag == 0) {
                            v = '否'
                        } else {
                            v = '是'
                        }
                        return (
                            <div>
                                {v}
                            </div>
                        )
                    }
                },
                {
                    label: '售后类型',
                    prop: 'afterTypeL',
                    width: '120',
                    render: (h, scope) => {
                        if (!scope.row.goodsAfterInfoList) return
                        if (scope.row.goodsAfterInfoList) {
                            scope.row.goodsAfterInfoList.forEach(item => {
                                if (item.afterType == 1) {
                                    item.afterTypeL = "退货退款"
                                } else if (item.afterType == 2) {
                                    item.afterTypeL = "换货"
                                } else if (item.afterType == 3) {
                                    item.afterTypeL = "仅退款"
                                }
                            })
                        }
                        return (
                            <div style="text-align:left;height:100%">
                                {
                                    scope.row.goodsAfterInfoList.map(item => {
                                        return (
                                            <div style="display:flex;flex-direction:column;justify-content:center;height:80px;">
                                                {item.afterTypeL || '--'}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: '售后件登记',
                    prop: 'goodsAfterInfo',
                    width: '120',
                    render: (h, scope) => {
                        if (!scope.row.goodsAfterInfoList) return
                        return (
                            <div style="text-align:left;height:100%">
                                {
                                    scope.row.goodsAfterInfoList.map(item => {
                                        return (
                                            <div style="display:flex;flex-direction:column;justify-content:center;height:80px;">
                                                <p>完好：{item.intact || 0}</p>
                                                <p>破损：{item.defective || 0}</p>
                                                <p>漏件：{item.missing || 0}</p>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: '是否理赔',
                    prop: 'claimFlagL',
                    width: '120',
                    render: (h, scope) => {
                        if (!scope.row.goodsAfterInfoList) return
                        if (scope.row.goodsAfterInfoList) {
                            scope.row.goodsAfterInfoList.forEach(item => {
                                if (item.claimFlag == 1) {
                                    item.claimFlagL = "是"
                                } else if (item.claimFlag == 2) {
                                    item.claimFlagL = "否"
                                } else {
                                    item.claimFlagL = ""
                                }
                            })
                        }
                        return (
                            <div style="text-align:left;height:100%">
                                {
                                    scope.row.goodsAfterInfoList.map(item => {
                                        return (
                                            <div style="display:flex;flex-direction:column;justify-content:center;height:80px;">
                                                <p>{item.claimFlagL || '--'}</p>

                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: '快递理赔金额',
                    prop: 'claimAmount',
                    width: '120',
                    render: (h, scope) => {
                        if (!scope.row.goodsAfterInfoList) return
                        return (
                            <div style="text-align:left;height:100%">
                                {
                                    scope.row.goodsAfterInfoList.map(item => {
                                        return (
                                            <div style="display:flex;flex-direction:column;justify-content:center;height:80px;">
                                                <p>{item.claimAmount || 0}</p>

                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: '售后件备注',
                    prop: 'afterRemarks',
                    width: '120',
                    render: (h, scope) => {
                        if (!scope.row.goodsAfterInfoList) return
                        return (
                            <div style="text-align:left;height:100%">
                                {
                                    scope.row.goodsAfterInfoList.map(item => {
                                        return (
                                            <div style="display:flex;flex-direction:column;justify-content:center;height:80px;">
                                                {item.remarks || '--'}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: '售后阶段',
                    prop: 'subsetStatusL',
                    width: '120',
                    render: (h, scope) => {
                        if (!scope.row.goodsAfterInfoList) return
                        if (scope.row.goodsAfterInfoList) {
                            scope.row.goodsAfterInfoList.forEach(item => {
                                this.afterList.forEach(itm => {
                                    if (item.subsetStatus == itm.value) {
                                        item.subsetStatusL = itm.label
                                    }
                                })
                            })
                        }
                        return (
                            <div style="text-align:left;height:100%">
                                {
                                    scope.row.goodsAfterInfoList.map(item => {
                                        return (
                                            <div style="display:flex;flex-direction:column;justify-content:center;height:80px;">
                                                {item.subsetStatusL || '--'}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: '发起退换货时间',
                    prop: 'afterSubmitTime',
                    width: '200',
                    render: (h, scope) => {
                        if (!scope.row.goodsAfterInfoList) return
                        return (
                            <div style="text-align:left;height:100%">
                                {
                                    scope.row.goodsAfterInfoList.map(item => {
                                        return (
                                            <div style="display:flex;flex-direction:column;justify-content:center;height:80px;">
                                                {item.submitTime || '--'}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: '结算方式',
                    prop: 'settlementModesL',
                    width: '120',
                    render: (h, scope) => {
                        if (!scope.row.orderWriteOffDetailList) return
                        if (scope.row.orderWriteOffDetailList) {
                            scope.row.orderWriteOffDetailList.forEach(item => {
                                if (item.settlementModes == 1) {
                                    item.settlementModesL = '在线支付'
                                } else if (item.settlementModes == 2) {
                                    item.settlementModesL = '货到付款'
                                } else if (item.settlementModes == 3) {
                                    item.settlementModesL = '线下全款'
                                } else if (item.settlementModes == 4) {
                                    item.settlementModesL = "定金+活动付款"
                                } else if (item.settlementModes == 5) {
                                    item.settlementModesL = "积分支付"
                                } else {
                                    item.settlementModesL = "--"
                                }
                            })
                        }
                        return (
                            <div style="text-align:left;height:100%">
                                {
                                    scope.row.orderWriteOffDetailList.map(item => {
                                        return (
                                            <div style="display:flex;flex-direction:column;justify-content:center;">
                                                {item.settlementModesL || '--'}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: '回款渠道',
                    prop: 'returnChannelName',
                    width: '120',
                    render: (h, scope) => {
                        if (!scope.row.orderWriteOffDetailList) return
                        if (scope.row.orderWriteOffDetailList) {
                            scope.row.orderWriteOffDetailList.forEach(item => {
                                this.channels.forEach(itm => {
                                    if (item.returnChannelId == itm.id) {
                                        item.returnChannelName = itm.name
                                    }

                                })
                            })

                        }
                        return (
                            <div style="text-align:left;height:100%">
                                {
                                    scope.row.orderWriteOffDetailList.map(item => {
                                        return (
                                            <div style="display:flex;flex-direction:column;justify-content:center;">
                                                {item.returnChannelName || '--'}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: '到账时间',
                    prop: 'receiveTime',
                    width: '200',
                    render: (h, scope) => {
                        if (!scope.row.orderWriteOffDetailList) return
                        return (
                            <div style="text-align:left;height:100%">
                                {
                                    scope.row.orderWriteOffDetailList.map(item => {
                                        return (
                                            <div style="display:flex;flex-direction:column;justify-content:center;">
                                                {item.receiveTime || '--'}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: '核销金额和时间',
                    prop: 'orderWriteOffDetail',
                    width: '200',
                    render: (h, scope) => {
                        if (!scope.row.orderWriteOffDetailList) return
                        return (
                            <div style="text-align:left;height:100%">
                                {
                                    scope.row.orderWriteOffDetailList.map(item => {
                                        return (
                                            <div style="display:flex;flex-direction:column;justify-content:center;">
                                                <div>￥{item.amount}</div>
                                                <div>{item.createdTime || '--'}</div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: '其他金额',
                    prop: 'otherAmount',
                    width: '120',
                    render: (h, scope) => {
                        return (
                            <div style="text-align:left;">
                                {scope.row.otherAmount || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '核销金额备注',
                    prop: 'writeOffRemarks',
                    width: '120',
                    render: (h, scope) => {

                        return (
                            <div style="text-align:left;">
                                {scope.row.writeOffRemarks || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '核销状态',
                    prop: 'writeOffStatus',
                    width: '120',
                    render: (h, scope) => {
                        let v = ''
                        if (scope.row.writeOffStatus) {
                            if (scope.row.writeOffStatus == 0) {
                                v = '待核销'
                            } else if (scope.row.writeOffStatus == 1) {
                                v = "部分核销"
                            } else if (scope.row.writeOffStatus == 2) {
                                v = "已核销"
                            } else if (scope.row.writeOffStatus == 3) {
                                v = "强制核销"
                            } else {
                                v = "核销退回"
                            }
                        } else {
                            v = '待核销'
                        }
                        return (
                            <div>
                                {scope.row.writeOffStatusLabel || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '核销人员',
                    prop: 'writeOffUserName',
                    width: '120',
                    render: (h, scope) => {
                        if (!scope.row.orderWriteOffDetailList) return
                        return (
                            <div style="text-align:left;height:100%">
                                {
                                    scope.row.orderWriteOffDetailList.map(item => {
                                        return (
                                            <div style="display:flex;flex-direction:column;justify-content:center;">
                                                <div>{item.userName}</div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                {
                    label: '审核状态',
                    prop: 'auditStatus',
                    width: '120',
                    render: (h, scope) => {
                        let v = ''
                        if (scope.row.auditStatus) {
                            if (scope.row.auditStatus == 1) {
                                v = '待审核'
                            } else if (scope.row.auditStatus == 2) {
                                v = "审核成功"
                            } else {
                                v = "驳回"
                            }
                        }
                        return (
                            <div>
                                {scope.row.auditStatusLabel || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '财务审核人员',
                    prop: 'financeUserName',
                    width: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.row.financeUserName || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '审核备注',
                    prop: 'remarks',
                    width: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                <p class="two" title={scope.row.remarks}>{scope.row.remarks || '--'}</p>
                            </div>
                        )
                    }
                },
                {
                    label: '是否已算提成',
                    prop: 'commissionFlagLabel',
                    width: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.row.commissionFlagLabel || '--'}
                            </div>
                        )
                    }
                },
                {
                    label: '提成备注',
                    prop: 'commissionRemark',
                    width: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                <p class="two" title={scope.row.commissionRemark}> {scope.row.commissionRemark || '--'}</p>
                            </div>
                        )
                    }
                },
                {
                  label: '申诉人/修改人',
                  width: '140',
                  prop: 'bonusApplyName',
                  render: (h, scope) => {
                      return (
                          <div>
                              {scope.row.bonusApplyName || '--'}<br/>
                              <p class="two" title={scope.row.reason}>
                               申诉/修改备注:{ scope.row.reason || '--'}
                              </p>
                          </div>

                      )
                  }
              },
              {
                  label: '审批人',
                  width: '140',
                  prop: 'auditUserName',
                  render: (h, scope) => {
                      return (
                        <div>
                              {scope.row.auditUserName || '--'}<br/>
                              <p class="two" title={scope.row.auditRemarks}>备注:{ scope.row.auditRemarks || '--'}</p>
                          </div>
                      )
                  }
              },
              {
                  label: '申诉审核状态',
                  width: '120',
                  prop: 'bonusReviewStatus',
                  render: (h, scope) => {
                    // 0-申诉审核中，1-撤销申诉，2-审核通过，3-申诉驳回，4-被改提成
                    let v=''
                    if (scope.row.bonusReviewStatus === 0) {
                        v = <i class="primary-bg round" />
                    }else if (scope.row.bonusReviewStatus === 1) {
                        v = <i class="info-bg round" />
                    }else if (scope.row.bonusReviewStatus === 2 || scope.row.bonusReviewStatus === 4) {
                        v = <i class="success-bg round" />
                    }else if (scope.row.bonusReviewStatus === 3) {
                        v = <i class="danger-bg round" />
                    }
                      return (
                          <div>
                            {v}{scope.row.bonusReviewStatusLabel || '--'}
                          </div>
                      )
                  }
              },
              {
                  label: '确认修改',
                  width: '90',
                  prop: 'bonusKnowFlag',
                  render: (h, scope) => {
                      return (
                          <div>
                              {scope.row.bonusReviewStatus ===4 ? (scope.row.bonusKnowFlag ===1?'已确认':'未确认'):'-'}
                          </div>
                      )
                  }
              },
                {
                    label: '财务操作',
                    width: '300',
                    fixed: 'right',
                    render: (h, scope) => {
                        //  let v = <div style="color:#409efe;cursor:pointer;" onClick={() => { this.commission(scope.row) }}>提成</div>
                        let v = ''
                        let v1 = ''
                        let v2 = ''
                        if (scope.row.roleType == 3) {
                            v = '--'
                            return
                        }
                        if ((scope.row.writeOffStatus == null || scope.row.writeOffStatus == 0) && scope.row.auditStatus == null) {
                            if (this.parArray.indexOf('lur') != -1) {
                                v = <div style="display:flex;flex-wrap:wrap">
                                    <div style="color:#409efe;cursor:pointer" onClick={() => { this.payment(scope.row, 'add') }}>录入回款内容</div>
                                </div>
                            }

                        } else if (scope.row.writeOffStatus == 1) {
                            if (scope.row.auditStatus == null || scope.row.auditStatus == 3) {
                                if (this.parArray.indexOf('lur') != -1) {
                                    v = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer" onClick={() => { this.payment(scope.row, 'add') }}>录入回款内容</div>
                                    </div>
                                }

                            } else if (scope.row.auditStatus == 2) {
                                if (this.parArray.indexOf('lur') != -1) {
                                    v = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer" onClick={() => { this.payment(scope.row) }}>修改录入回款内容</div>
                                    </div>
                                }
                                if (this.parArray.indexOf('schedule') != -1) {
                                    v1 = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer;margin-right:10px" onClick={() => { this.apply('shenheStep', scope.row) }}>进度</div>
                                    </div>
                                }
                                if (this.parArray.indexOf('Commission') != -1) {
                                    v2 = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer;" onClick={() => { this.commission(scope.row) }}>提成</div>
                                    </div>
                                }
                            }

                        } else if (scope.row.writeOffStatus == 3) {
                            if (scope.row.auditStatus == 1) {
                                if (this.parArray.indexOf('shenh') != -1) {
                                    v = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer;margin-right:10px" onClick={() => { this.apply('shenheList', scope.row) }} >审核</div>
                                    </div>
                                }
                                if (this.parArray.indexOf('schedule') != -1) {
                                    v1 = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer;margin-right:10px" onClick={() => { this.apply('shenheStep', scope.row) }}>进度</div>
                                    </div>
                                }
                            } else if (scope.row.auditStatus == 3) {
                                if (this.parArray.indexOf('lur') != -1) {
                                    v = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer" onClick={() => { this.payment(scope.row, 'add') }}>录入回款内容</div>
                                    </div>
                                }
                            } else if (scope.row.auditStatus == 2) {
                                if (this.parArray.indexOf('lur') != -1) {
                                    v = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer" onClick={() => { this.payment(scope.row) }}>修改录入回款内容</div>
                                    </div>
                                }
                                if (this.parArray.indexOf('schedule') != -1) {
                                    v1 = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer;margin-right:10px" onClick={() => { this.apply('shenheStep', scope.row) }}>进度</div>
                                    </div>
                                }
                                if (this.parArray.indexOf('Commission') != -1) {
                                    v2 = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer;" onClick={() => { this.commission(scope.row) }}>提成</div>
                                    </div>
                                }
                            }

                        } else if (scope.row.writeOffStatus == 2) {
                            if (scope.row.auditStatus == 1) {
                                if (this.parArray.indexOf('shenh') != -1) {
                                    v = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer;margin-right:10px" onClick={() => { this.apply('shenheList', scope.row) }} >审核</div>
                                    </div>
                                }
                                if (this.parArray.indexOf('schedule') != -1) {
                                    v1 = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer;margin-right:10px" onClick={() => { this.apply('shenheStep', scope.row) }}>进度</div>
                                    </div>
                                }
                            } else if (scope.row.auditStatus == 3) {
                                if (this.parArray.indexOf('lur') != -1) {
                                    v = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer" onClick={() => { this.payment(scope.row) }}>录入回款内容</div>
                                    </div>
                                }
                                // v = <div style="display:flex;flex-wrap:wrap">
                                //     <div style="color:#409efe;cursor:pointer" onClick={() => { this.payment(scope.row) }}>录入回款内容</div>
                                // </div>
                            } else if (scope.row.auditStatus == 2) {
                                if (this.parArray.indexOf('lur') != -1) {
                                    v = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer" onClick={() => { this.payment(scope.row) }}>修改录入回款内容</div>
                                    </div>
                                }
                                if (this.parArray.indexOf('schedule') != -1) {
                                    v1 = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer;margin-right:10px" onClick={() => { this.apply('shenheStep', scope.row) }}>进度</div>
                                    </div>
                                }
                                if (this.parArray.indexOf('Commission') != -1) {
                                    v2 = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer;" onClick={() => { this.commission(scope.row) }}>提成</div>
                                    </div>
                                }
                            }
                        } else if (scope.row.writeOffStatus == 4) {
                            if (scope.row.auditStatus == 3) {
                                if (this.parArray.indexOf('lur') != -1) {
                                    v = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer" onClick={() => { this.payment(scope.row) }}>修改录入回款内容</div>
                                    </div>
                                }
                                if (this.parArray.indexOf('schedule') != -1) {
                                    v1 = <div style="display:flex;flex-wrap:wrap">
                                        <div style="color:#409efe;cursor:pointer;margin-right:10px" onClick={() => { this.apply('shenheStep', scope.row) }}>进度</div>
                                    </div>
                                }
                                // if (scope.row.roleType == 1) {
                                //     v = <div style="display:flex;flex-wrap:wrap">
                                //         <div style="color:#409efe;cursor:pointer;margin-right:10px" onClick={() => { this.apply('shenheStep', scope.row) }}>进度</div>
                                //         <div style="color:#409efe;cursor:pointer" onClick={() => { this.payment(scope.row) }}>修改录入回款内容</div>
                                //     </div>
                                // } else if (scope.row.roleType == 2) {
                                //     v = <div style="display:flex;flex-wrap:wrap">
                                //         <div style="color:#409efe;cursor:pointer;margin-right:10px" onClick={() => { this.apply('shenheStep', scope.row) }}>进度</div>
                                //         <div style="color:#409efe;cursor:pointer" onClick={() => { this.payment(scope.row) }}>修改录入回款内容</div>
                                //     </div>
                                // }
                            }
                        }
                        return (
                            <div style="display:flex;flex-wrap:wrap">
                                <div>{v}</div>
                                <div>{v1}</div>
                                <div>{v2}</div>
                            </div>

                        )
                    }
                }],
            activeName: 'goods',
            multipleSelection: [],// 多选
            isPayment: false,
            file: '',
            status: '',
            afterList: [],
            channels: [],
            settlementTypes: [
                {
                    id: '1',
                    name: '在线支付'
                },
                {
                    id: '2',
                    name: '货到付款'
                },
                {
                    id: '3',
                    name: '线下全款'
                },
                {
                    id: '4',
                    name: '定金+活动付款'
                },
                {
                    id: '5',
                    name: '积分支付'
                },
            ],
            currentRow: {},
            parArray: [],
            limits: [],
            allOrderRoleNameList: []
        }
    },
    watch: {
        orgCodeList(val, oldVal) {
            val.forEach(item => {
                item.label = item.reallyName
                item.value = item.id
            })
            const index = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '公司部门' })
            this.searchFormConfig.formconfig.itemList[index].option = val
        },
    },
    created() {
        this.getStatus()
        this.getButtonTreeDto()
        //回款渠道
        this.getReturn()
        this.initSearchList() // 初始化，搜索需要的列表数据
        this.fetchData()
        // this.getApproverList() // 审核人 列表
        this.getDictionaryGroups('all_order_origin,order_generate_type,order_status_logistics,after_sale_subset_status,order_bonus_type,order_bonus_review_status')
        //this.getDictionaries('order_generate_type')
        //this.getDictionaries('order_status_logistics')
        //this.getDictionaries('after_sale_subset_status')
        // this.setSearchDictionaries('提成类型', 'order_bonus_type')
        // this.setSearchDictionaries('申诉审核状态', 'order_bonus_review_status')
        //this.getDictionaries('order_bonus_type')
        //this.getDictionaries('order_bonus_review_status')
    },
    methods: {
        getListView() {
            // 根据菜单按钮配置的编码显示字段，第一个orderNo是必显示的字段，冻结住
            let columns = []
            this.columns.forEach(item => {
                if (!item.prop || item.prop === 'orderNo' ||  this.parArray.indexOf('ao_columns_' + item.prop) != -1) {
                    columns.push(item)
                }
            })
            this.columns = columns
        },
        getButtonTreeDto() {
            this.axios
                .get('/sys/v1/menu/button/user/tree?winType=1', {
                    headers: {
                        isLoading: false
                    }
                })
                .then((res) => {
                    //console.log(res)
                    if (res.code == 0) {
                        const params = res.data.buttonTreeDto.filter(
                            (item) => item.menuCode === 'allOrder'
                        )
                        params[0].buttonList.forEach((item) => {
                            this.parArray.push(item.code)
                        })
                        this.getListView()
                    } else {
                        if (res.code == 103) {
                            this.$router.replace('home/welcome') // 如果没有配置菜单权限就跳到欢迎页面
                        }
                        // this.$message({ type: "warning", message: res.message });
                    }
                })

        },
        lookLogistics(row) {
            this.dialog.visible = true
            this.dialog.type = 'logistics'
            this.dialog.title = '物流信息'
            this.axios.get('/neworder/orderAll/getLogisticsTimeNodeDtoInfo/' + row.id).then((res) => {
                if (res.code == 0) {
                    this.logisticsNode = res.data
                } else {
                    this.$message.error(res.message)
                }
            }).catch((err) => {
                console.log(err)
                // this.btnLoading = false
            })
        },
        submitComission() {
            let data = {
                id: this.commissionForm.id,
                commissionFlag: this.commissionForm.commissionFlag,
                commissionRemark: this.commissionForm.commissionRemark,
            }
            this.axios.post('/neworder/orderAll/editAddCommission', data).then((res) => {
                if (res.code == 0) {
                    this.$message.success('操作成功！')
                    this.isCommission = false
                    this.fetchData('search', true, true)
                } else {
                    this.$message.error(res.message)
                }
            }).catch((err) => {
                console.log(err)
                // this.btnLoading = false
            })
        },
        commission(row) {
            this.isCommission = true
            this.commissionForm.id = row.id
            if (row.commissionFlag == null) {
                row.commissionFlag = ''
            }
            this.commissionForm.commissionFlag = String(row.commissionFlag)
            this.commissionForm.commissionRemark = row.commissionRemark
        },
        scrollToTop(e) {
            let scrollTop = e.target.scrollTop;
            if (scrollTop >= 500) {
                this.$nextTick(() => {
                    this.tableHeight = '600';
                })

            }
            if (scrollTop == 0) {
                this.tableHeight = ''
            }
        },
        submitApply() {
            this.$refs.shenheList.auditSubmitList()
            this.fetchData('search', true, true)
            this.getStatus()
        },
        // onImport() {
        //     this.isImport = true
        //     this.file = ''
        // },
        downloadTemplate() {
            if (this.isType == 2) {
                this.downloadlink(' https://fenxiao.muruji.com/5eck/%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BFv1.0.2.xls')
            } else if (this.isType == 1) {
                // this.downloadlink('https://fenxiao.muruji.com/5eck%E8%B4%A2%E5%8A%A1%E6%89%B9%E9%87%8F%E6%A0%B8%E9%94%80%E6%A8%A1%E6%9D%BFv1.0.1.xls')
                this.onApplyListHExport()
            } else if (this.isType == 3) {
                this.onApplyListExport()
            } else if (this.isType == 4) {
                this.onComissionListExport()
            }

        },
        submitF() {
            if (this.file == '') {
                this.$message.error('请选择文件')
                return
            }
            if (this.isType == 2) {
                const formData = new FormData()
                formData.append('file', this.file)
                let data = {
                    file: this.file
                }
                this.$api.importLogistics1(formData).then((res) => {
                    if (res.code == 0) {
                        this.$message.success('操作成功')
                        this.downloadlink(res.data.errorUrl)
                        this.isImport = false
                        this.fetchData('search', true, true)
                    }
                })
            } else if (this.isType == 1) {
                const formData = new FormData()
                formData.append('file', this.file)
                let data = {
                    file: this.file
                }
                this.$api.importLogistics2(formData).then((res) => {
                    if (res.code == 0) {
                        this.$message.success('操作成功')
                        this.downloadlink(res.data.errorUrl)
                        this.isImport = false
                        this.fetchData('search', true, true)
                    }
                })
            } else if (this.isType == 3) {
                const formData = new FormData()
                formData.append('file', this.file)
                let data = {
                    file: this.file
                }
                this.$api.importLogistics3(formData).then((res) => {
                    if (res.code == 0) {
                        this.$message.success('操作成功')
                        this.downloadlink(res.data.errorUrl)
                        this.isImport = false
                        this.fetchData('search', true, true)
                    }
                })
            } else if (this.isType == 4) {
                const formData = new FormData()
                formData.append('file', this.file)
                let data = {
                    file: this.file
                }
                this.$api.importLogistics4(formData).then((res) => {
                    if (res.code == 0) {
                        this.$message.success('操作成功')
                        this.downloadlink(res.data.errorUrl)
                        this.isImport = false
                        this.fetchData('search', true, true)
                    }
                })
            }

        },
        onApplyListHExport() {
            let params = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                status: this.page.status
            }
            const searchFormVal = this.searchFormVal
            // console.log(searchFormVal)
            params = Object.assign(params, searchFormVal)
            // console.log(params, 'params')
            if (searchFormVal.createdTime) {
                params.startTime = searchFormVal.createdTime[0]
                params.endTime = searchFormVal.createdTime[1]
            }
            if (params.orgCode) {
                params.orgCode = params.orgCode[params.orgCode.length - 1]
            } else {
                params.orgCode = ''
            }
            // 去除字符串 前后 空格
            for (const item in params) { if (typeof params[item] === 'string') { params[item] = params[item].trim() } }
            params.status = this.status
            this.axios.post('/neworder/orderAll/exportWriteOffTemplate', params).then((res) => {
                if (res.code == 0) {
                    this.downloadlink(res.data)
                    this.$message.success('操作成功！')

                } else {
                    this.$message.error(res.message)
                }
            }).catch((err) => {
                console.log(err)
                // this.btnLoading = false
            })
        },
        onApplyListExport() {
            let params = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                status: this.page.status
            }
            const searchFormVal = this.searchFormVal
            // console.log(searchFormVal)
            params = Object.assign(params, searchFormVal)
            // console.log(params, 'params')
            if (searchFormVal.createdTime) {
                params.startTime = searchFormVal.createdTime[0]
                params.endTime = searchFormVal.createdTime[1]
            }
            if (params.orgCode) {
                params.orgCode = params.orgCode[params.orgCode.length - 1]
            } else {
                params.orgCode = ''
            }
            // 去除字符串 前后 空格
            for (const item in params) { if (typeof params[item] === 'string') { params[item] = params[item].trim() } }
            params.status = this.status
            this.axios.post('/neworder/orderAll/exportAuditTemplate', params).then((res) => {
                if (res.code == 0) {
                    this.downloadlink(res.data)
                    this.$message.success('操作成功！')

                } else {
                    this.$message.error(res.message)
                }
            }).catch((err) => {
                console.log(err)
                // this.btnLoading = false
            })
        },
        onComissionListExport() {
            let params = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                status: this.page.status
            }
            const searchFormVal = this.searchFormVal
            // console.log(searchFormVal)
            params = Object.assign(params, searchFormVal)
            // console.log(params, 'params')
            if (searchFormVal.createdTime) {
                params.startTime = searchFormVal.createdTime[0]
                params.endTime = searchFormVal.createdTime[1]
            }
            if (params.orgCode) {
                params.orgCode = params.orgCode[params.orgCode.length - 1]
            } else {
                params.orgCode = ''
            }
            // 去除字符串 前后 空格
            for (const item in params) { if (typeof params[item] === 'string') { params[item] = params[item].trim() } }
            params.status = this.status
            this.axios.post('/neworder/orderAll/exportCommission', params).then((res) => {
                if (res.code == 0) {
                    this.downloadlink(res.data)
                    this.$message.success('操作成功！')

                } else {
                    this.$message.error(res.message)
                }
            }).catch((err) => {
                console.log(err)
                // this.btnLoading = false
            })
        },
        onApplierExport() {
            let params = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                status: this.page.status
            }
            const searchFormVal = this.searchFormVal
            // console.log(searchFormVal)
            params = Object.assign(params, searchFormVal)
            // console.log(params, 'params')
            if (searchFormVal.createdTime) {
                params.startTime = searchFormVal.createdTime[0]
                params.endTime = searchFormVal.createdTime[1]
            }
            if (params.orgCode) {
                params.orgCode = params.orgCode[params.orgCode.length - 1]
            } else {
                params.orgCode = ''
            }
            // 去除字符串 前后 空格
            for (const item in params) { if (typeof params[item] === 'string') { params[item] = params[item].trim() } }
            params.status = this.status
            this.axios.post('/neworder/orderAll/exportList', params).then((res) => {
                if (res.code == 0) {
                    this.downloadlink(res.data)
                    this.$message.success('操作成功！')

                } else {
                    this.$message.error(res.message)
                }
            }).catch((err) => {
                console.log(err)
                // this.btnLoading = false
            })
        },
        shenheState() {
            this.dialog.visible = false
        },
        actionDialog() {
            this.$refs['paymentForm'].validate((valid) => {
                if (valid) {
                    let data = {
                        status: this.paymentForm.status,
                        orderWriteOffDetailList: this.paymentForm.list,
                        allOrderId: this.currentRow.id,
                        id: this.currentRow.orderWriteOffId,
                        auditStatus: this.currentRow.auditStatus,
                        writeOffRemarks: this.paymentForm.writeOffRemarks
                    }
                    this.axios.post('neworder/orderAll/saveReturnInfo', data).then((res) => {
                        if (res.code == 0) {
                            this.$message.success('操作成功')
                            this.isPayment = false
                            this.fetchData('search', true, true)
                            this.getStatus()
                        }
                    })
                }
            })

        },
        changeType(val) {
            this.paymentForm.status = ''
            let total = 0
            let obj = {
                id: '1',
                name: '部分核销'
            }
            let obj1 = {
                id: '2',
                name: '已核销'
            }
            let obj2 = {
                id: '3',
                name: '强制核销'
            }
            this.types = []
            this.paymentForm.list.forEach(item => {
                total = Number(total) + Number(item.amount)
            })
            console.log(total, this.currentRow.receivableAmount)
            if (total >= this.currentRow.receivableAmount) {
                this.types.push(obj1)
            } else if (total < this.currentRow.receivableAmount) {
                this.types.push(obj)
                this.types.push(obj2)
            }
            this.hList[0].yAmount = total.toFixed(2)
            let tem = Number(this.hList[0].yAmount) - Number(this.currentRow.receivableAmount)
            if (Number(tem) > 0) {
                this.hList[0].otherAmount = tem.toFixed(2)
            } else {
                this.hList[0].otherAmount = '0.00'
            }

        },
        onChangeLogisticsStatus(val) {
            this.status = val
            this.currentStatus = val
            if (this.currentStatus == 13 || this.currentStatus == 14 || this.currentStatus == 15 || this.currentStatus == 16) {
                this.searchFormVal.bonusReviewStatus = ''
                this.showBonusStatus = false
                // 隐藏申诉审核状态
                this.searchFormConfig.formconfig.itemList[13].visible = 'hide'

            }else{
                this.searchFormConfig.formconfig.itemList[13].visible = 'show'
            }
            this.$refs['formAttr'].forceUpdate()
            console.log('onChangeLogisticsStatus>>',this.searchFormConfig.formconfig.itemList[13])
            this.fetchData('search', true, true)
            this.getStatus()
        },
        getReturn() {
            this.axios.get('neworder//orderAll/returnChannel').then((res) => {
                if (res.code == 0) {
                    this.channels = res.data
                }
            })
        },
        getStatus() {
            let params = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                status: this.page.status
            }
            const searchFormVal = this.searchFormVal
            // console.log(searchFormVal)
            params = Object.assign(params, searchFormVal)
            // console.log(params, 'params')
            if (searchFormVal.createdTime) {
                params.startTime = searchFormVal.createdTime[0]
                params.endTime = searchFormVal.createdTime[1]
            }

            // 去除字符串 前后 空格
            for (const item in params) { if (typeof params[item] === 'string') { params[item] = params[item].trim() } }
            params.status = this.status
            if (params.orgCode) {
                params.orgCode = params.orgCode[params.orgCode.length - 1]
            }
            this.axios.post('neworder/orderAll/statistics', params).then((res) => {
                if (res.code == 0) {
                    this.amount = res.data.amount
                    this.actualReceivedAmount = res.data.actualReceivedAmount
                    for (let j = 0; j < res.data.statisticsList.length; j++) {
                        if(this.logisticsStatus[j]) {
                            this.logisticsStatus[j].total = res.data.statisticsList[j]
                        }
                    }
                }
            })
        },
        // 获取字典数据
        getDictionaryGroups(type) {
            const params = { groupIds: type }
            this.$api.dictionaryGroups(params).then((res) => {
                for (const key in res.data) {
                    if (key == 'all_order_origin') {
                        let list = []
                        list = res.data[key]
                        const payIndex = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '订单来源' })
                        list.forEach(item => {
                            item.label = item.dictName
                            item.value = item.dictId
                        })
                        this.searchFormConfig.formconfig.itemList[payIndex].option = list
                    }

                    if (key == 'order_generate_type') {
                        let list = []
                        list = res.data[key]
                        const payIndex1 = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '订单分类' })
                        list.forEach(item => {
                            item.label = item.dictName
                            item.value = item.dictId
                        })
                        this.searchFormConfig.formconfig.itemList[payIndex1].option = list
                    }
                    if (key == 'order_status_logistics') {
                        let list = []
                        list = res.data[key]

                        list.forEach(item => {
                            item.label = item.dictName
                            item.value = item.dictId
                        })
                        this.orderList = list
                    }
                    if (key == 'after_sale_subset_status') {
                        let list = []
                        list = res.data[key]

                        list.forEach(item => {
                            item.label = item.dictName
                            item.value = item.dictId
                        })
                        this.afterList = list
                    }
                    if (key == 'order_bonus_type') {
                        let list = []
                        list = res.data[key]

                        list.forEach(item => {
                            item.label = item.dictName
                            item.value = item.dictId
                        })
                        const index = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '提成类型' })
                        this.searchFormConfig.formconfig.itemList[index].option =  list
                    }
                    if (key == 'order_bonus_review_status') {
                        let list = []
                        list = res.data[key]

                        list.forEach(item => {
                            item.label = item.dictName
                            item.value = item.dictId
                        })
                        const index = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '申诉审核状态' })
                        this.searchFormConfig.formconfig.itemList[index].option =  list
                    }
                }
            }).catch((err) => {
                console.log(err)
            })
            const payIndex = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '财务审核状态' })
            let arr = [
                {
                    label: '待审核',
                    value: '1'
                },
                {
                    label: '审核通过',
                    value: '2'
                },
                {
                    label: '驳回',
                    value: '3'
                },
            ]
            this.searchFormConfig.formconfig.itemList[payIndex].option = arr
            // const payIndex1 = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '订单分类' })
            // let arr1 = [
            //     {
            //         label: '全部',
            //         value: ' '
            //     },
            //     {
            //         label: '手动单',
            //         value: '1'
            //     },
            //     {
            //         label: '自动单',
            //         value: '2'
            //     },
            //     {
            //         label: '非五域导入单',
            //         value: '3'
            //     },
            // ]
            // this.searchFormConfig.formconfig.itemList[payIndex1].option = arr1
            const payIndex2 = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '是否货到付款' })
            let arr2 = [
                {
                    label: '是',
                    value: '1'
                },
                {
                    label: '否',
                    value: '0'
                },

            ]
            this.searchFormConfig.formconfig.itemList[payIndex2].option = arr2
        },
        orderImport(fileObj) {
            // console.log(fileObj, 'fileObj')
            this.file = fileObj.file
        },
        onImport(type) {

            this.isImport = true
            this.isType = type
            this.file = ''
            this.$nextTick(() => {
                this.$refs['tops'].clearFiles()
            })
        },
        mark() {
            this.isSingle = true
        },
        //添加核销
        addPrice() {
            let obj = {
                settlementModes: '',
                returnChannelId: '',
                amount: '',
                receiveTime: ''
            }
            this.paymentForm.list.push(obj)
        },
        //回款
        payment(row, type) {
            this.isPayment = true
            this.currentRow = row
            this.hList[0].orderNo = this.currentRow.orderNo
            this.hList[0].actualReceivedAmount = this.currentRow.actualReceivedAmount
            this.hList[0].receivableAmount = this.currentRow.receivableAmount
            if (row.orderWriteOffId) {
                this.getEditC(row.orderWriteOffId)
            } else {

                this.hList[0].yAmount = '0.00'
                this.hList[0].otherAmount = '0.00'
                this.paymentForm.list = []
                let obj = {
                    id: '',
                    settlementModes: '',
                    returnChannelId: '',
                    amount: '',
                    receiveTime: ''
                }
                this.paymentForm.list = [obj]
                this.paymentForm.status = ''
                this.paymentForm.writeOffRemarks = ''
                this.$nextTick(() => {
                    this.$refs.paymentForm.clearValidate()
                })


            }

            // if (type == 'edit') {

            // }
        },
        getEditC(id) {
            this.axios.get('neworder/orderAll/getReturnInfo/' + id).then(res => {
                if (res.code == 0) {
                    this.paymentForm.status = String(res.data.status)
                    if (res.data.status == 4) {
                        this.paymentForm.status = ''
                    }
                    res.data.orderWriteOffDetailList.forEach(item => {
                        item.settlementModes = String(item.settlementModes)
                        // item.returnChannelId = item.returnChannelId

                    })
                    this.paymentForm.list = res.data.orderWriteOffDetailList
                    if (res.data.orderWriteOffDetailList.length == 0) {
                        this.paymentForm.list = []
                        let obj = {
                            id: '',
                            settlementModes: '',
                            returnChannelId: '',
                            amount: '',
                            receiveTime: ''
                        }
                        this.paymentForm.list = [obj]
                    }
                    let total = 0
                    let obj = {
                        id: '1',
                        name: '部分核销'
                    }
                    let obj1 = {
                        id: '2',
                        name: '已核销'
                    }
                    let obj2 = {
                        id: '3',
                        name: '强制核销'
                    }
                    this.types = []
                    this.paymentForm.list.forEach(item => {
                        total = Number(total) + Number(item.amount)
                    })
                    //console.log(total, this.currentRow.receivableAmount)
                    if (total >= this.currentRow.receivableAmount) {
                        this.types.push(obj1)
                    } else if (total < this.currentRow.receivableAmount) {
                        this.types.push(obj)
                        this.types.push(obj2)
                    }
                    this.hList[0].yAmount = total.toFixed(2)
                    let tem = Number(this.hList[0].yAmount) - Number(this.currentRow.receivableAmount)
                    if (Number(tem) > 0) {
                        this.hList[0].otherAmount = tem.toFixed(2)
                    } else {
                        this.hList[0].otherAmount = '0.00'
                    }
                    this.paymentForm.writeOffRemarks = res.data.writeOffRemarks
                }
            })
        },
        //审核进度
        apply(type, row) {
            this.currentRow = row
            this.dialog.visible = true
            this.dialog.type = type
            this.dialog.title = type === 'shenheList' ? '订单财务审核' : '审核流程'
            this.dialog.row = row
            if (type == 'shenheStep') {
                this.getProcess(row.id)
            }
        },
        getProcess(id) {
            this.axios.get('neworder/orderAll/getAuditLog/' + id).then(res => {
                if (res.code == 0) {
                    this.applys = res.data
                }
            })
        },
        // 复制
        copyInfo(row) {
            // console.log(row, 'row')
            const that = this
            // let inline = this.line.find((res) => res.id == row.userDitch);
            const info =
                (row.orderNo == null ? '无' : row.orderNo)
            that.$copyText(info).then(
                function (e) {
                    that.$message({
                        type: 'success',
                        message: '复制成功'
                    })
                },
                function (e) {
                    that.$message({
                        type: 'warning',
                        message: '复制失败'
                    })
                }
            )
        },
        // 设置 搜索 筛选 字典 值
        setSearchDictionaries(str, keyVal) {
            const dictionaries = this.dictionaries
            const payIndex = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === str })
            for (const key in dictionaries) {
                if (key === keyVal) {
                    dictionaries[key].forEach(item => {
                        item.label = item.dictName
                        item.value = item.dictId
                    })
                    this.searchFormConfig.formconfig.itemList[payIndex].option = dictionaries[key]
                    break
                }
            }
            console.log('>>', this.searchFormConfig.formconfig.itemList)
        },
        // 接受表单组件的数据
        dialogClick(val, state) {
            this.searchFormVal = val
            // this.formFiledData = Object.assign(this.formFiledData, val)
            this.fetchData('search', true, true)
            this.getStatus()
        },
        fetchData(type, isRefresh, isInit) {
            this.loading = true;
            if (type === 'reset') {
                this.$refs['searchForm'].resetFields()
                this.page.pageNo = 1
                this.page.pageSize = 10
                this.page.currentPage = 1
            }
            let params = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                status: this.page.status
            }
            if (isRefresh && this.page.list.length === 1 && this.page.currentPage > 1) {
                // debugger
                this.page.currentPage = this.page.currentPage - 1
                params.pageNo = this.page.pageNo - 1
            }
            if (isInit) {
                params.pageNo = 1
                this.page.currentPage = 1
            }

            if (type === 'search') {
                const searchFormVal = this.searchFormVal
                // console.log(searchFormVal)
                params = Object.assign(params, searchFormVal)
                // console.log(params, 'params')
                if (searchFormVal.createdTime) {
                    params.startTime = searchFormVal.createdTime[0]
                    params.endTime = searchFormVal.createdTime[1]
                }

                // 去除字符串 前后 空格
                for (const item in params) { if (typeof params[item] === 'string') { params[item] = params[item].trim() } }
            }
            params.status = this.status
            if (params.orgCode) {
                params.orgCode = params.orgCode[params.orgCode.length - 1]
            }
            console.log('>>',params)
            this.axios.post('/neworder/orderAll/pageList', params).then((res) => {
                if (res.code === 0) {
                    this.page.list = res.data.list
                    this.page.totalNum = res.data.totalNum
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false;
            }).catch((err) => {
                console.log(err)
                this.loading = false;
            })
        },
        handleCurrentChange(currentChange) {
            this.page.pageNo = currentChange
            this.fetchData('search')
        },
        handleSizeChange(sizeChange) {
            this.page.currentPage = 1
            this.page.pageSize = sizeChange
            this.fetchData('search')
        },
        // 多选
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        // 初始化，搜索需要的列表数据
        initSearchList() {
            const params = { pageNo: 1, pageSize: 1001 }
            this.getOrgTreeList() // 公司部门
            this.getSalesAuthority(params) // 跟进客服
        },
        // 公司部门
        getOrgTreeList(params) {
            // orgProcessOrgList
            const paramsVersion = { 'request': { 'orgName': '', 'orgType': '' }, 'version': '' }
            this.$api.orgTreeList(paramsVersion).then((res) => {
                this.orgCodeList = res.data

                // id 为 1 的超级管理员不做默认
                const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (userInfo && userInfo.id !== 1) {
                    if (res.data[0].children) {
                        // const orgCode = JSON.parse(sessionStorage.getItem('orgCode'))
                        if (this.searchForm && this.searchForm.orgCode) {
                            this.searchForm.orgCode = [...userInfo.orgCodes]
                        }
                    } else {
                        this.searchForm.orgCode.push(userInfo.orgCode)
                    }
                    // if (this.isFirst > 2) {
                    //     this.fetchData('search')
                    // }
                }
                // this.isFirst++
            }).catch((err) => {
                console.log(err)
            })
        },
    }
}
</script>

<style scoped lang="scss">
.p-title {
    font-weight: bold;
    margin-bottom: 20px;
}

::v-deep .search-form1 .el-date-editor--daterange .el-input__inner {
    width: 260px !important;
}

::v-deep .search-form1 .el-input__inner {
    width: 260px !important;
}

.dialog-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    .cancel {
        width: 120px;
        height: 36px;
        border: 1px solid #d9d9d9;
        opacity: 1;
        border-radius: 4px;
    }

    .affirm {
        width: 120px;
        height: 36px;
        background: #4168e7;
        opacity: 1;
        border-radius: 4px;
    }
}

/deep/ .el-upload-dragger {
    width: 600px !important;
}

.a-container .search-form1 {
    display: flex;
    flex-wrap: wrap;

    .el-form-item {
        width: 100%;
        max-width: 303px;
        min-width: 300px;

        .el-form-item__content {

            .el-input,
            .el-select,
            .el-date-picker {
                width: 300px;
            }
        }
    }
}

/deep/.hide-content {
    display: none !important;
}

/deep/.show-content {
    display: inline-block;
}

/deep/.el-link {
    margin: 0 5px;
}

/deep/ .el-button {
    border: none;
}

/deep/.el-table th>.cell {
    text-align: unset;
}

/deep/.el-table td {
    text-align: unset;
}

.el-table__body-wrapper .el-table__body .el-table__row .cell {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* 可以显示的行数，超出部分用...表示*/
    -webkit-box-orient: vertical;
}

.examination {
    .content {
        h3 {
            .el-button {
                color: #4168E7;
                background: #FFFFFF;
                border: 1px solid #4168E7;
            }
        }
    }
}

.examination {
    .content {
        h3 {
            .el-button {
                float: right;
                width: 121px;
                height: 36px;
                border-radius: 4px;
                padding: 0;
                margin-top: -4px;
            }
        }

        .lb-table {
            .el-table {
                .el-table__fixed-body-wrapper {
                    .el-table__body {
                        .el-table__row {
                            .cell {

                                // 操作按钮
                                .el-link {
                                    margin: 0 5px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

.dialogBtnright {
    text-align: right;
}

/deep/.el-table__row td .cell span,
/deep/.el-table__row td .cell div p {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    /* 可以显示的行数，超出部分用...表示*/
    -webkit-box-orient: vertical;
}
/deep/.el-table__row td .cell div p.two {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* 可以显示的行数，超出部分用...表示*/
    -webkit-box-orient: vertical;
}

/deep/.el-select {
    border-left: none;
    border-right: none;

    input {
        border-left: 1px solid #d8dce5 !important;
        border-right: 1px solid #d8dce5 !important;
        border-radius: 5px !important;
    }
}

/deep/.el-dialog__body {
    padding: 30px;
}

/deep/.el-scrollbar {
    height: 10px;
}

/deep/.el-scrollbar__bar.is-horizontal {
    height: 9px;

}

/deep/ .el-form-item__label {
    padding: 0 10px 0 0;
}

.page {
    text-align: center;
    margin: 10px auto;
}

.but-list {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .left {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;

        /deep/ .el-button {
            min-width: 120px;
            height: 36px;
            border-radius: 4px;
            font-size: 16px;
            margin-left: 0px;
            margin-right: 10px;
        }
    }

    .right {
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;

        /deep/ .el-button {
            min-width: 120px;
            height: 36px;
            border-radius: 4px;
            font-size: 16px;
        }
    }
}
/deep/{
    /*圆点*/
.round {
  width: 10px;
  height: 10px;
  border-radius: 50px;
  display: inline-block;
}
.primary-bg {
  background-color: #409eff !important;
}

.success-bg {
  background-color: #12ab62 !important;
}

.warning-bg {
  background-color: #e6a23c !important;
}

.danger-bg {
  background-color: #f56c6c !important;
}

.info-bg {
  background-color: #909399 !important;
}
}
</style>
